<template>
  <div class="TestBody" @click="Clicked" >
    <slot>
    </slot>
  </div>
</template>

<script>
export default {
  props:{
    StartTime:null,
  },

  methods:{
    Clicked:function(){
      this.$emit("Clicked",new Date() - this.StartTime);
    }
  }
}
</script>

<style scoped>
    .TestBody{
        width: 40vw;
        aspect-ratio: 1/1;
        border-radius: 20px;
        border: 5px solid white;
        background-color: firebrick;
        margin: 5vw;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>